<template>
  <mrc_ess_myDialog
    v-model="dialog"
    :width="600"
    @success="telsave"
    @cancel="telclose"
  >
    <template>
      <!-- <div class="pl-8 mt-4">
        <a class="filePath"> aaaa </a>
      </div> -->
      <div class="pl-4">
        <a class="filePath">
          <span @click="getDirectory()">{{
            this.$t("label_001-018_001-017-003_folder_root_path")
          }}</span>
          <span class="mx-3" v-if="directory_path && directory_path.length != 0"
            >></span
          >
        </a>
        <a
          class="filePath"
          v-for="(item, index) in directory_path"
          :key="index"
        >
          <span @click="getDirectory(item.uuid, item.tricode)"
            >[{{ INT(item.directory_name) }}]</span
          >
          <span v-if="index != directory_path.length - 1" class="mx-3">></span>
        </a>
      </div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                {{ $t("label_001-018_001-017-002_key_file_directory") }}
              </th>
              <th class="text-left">{{ $t("label_Date") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in directoryDate" :key="item.name">
              <td>
                <a
                  class="directory"
                  @dblclick="getDirectory(item.uuid, item.tricode)"
                  @click="SelectDirectory(index)"
                  :class="{ active: categoryIndex == index }"
                  >{{ INT(item.directory_name) }}</a
                >
              </td>
              <td>
                <a
                  class="directory"
                  @dblclick="getDirectory(item.uuid, item.tricode)"
                  >{{ item.created_utc_datetime | changeDate() }}</a
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </mrc_ess_myDialog>
</template>

<script>
import { popBoxGetFileDirectory, fileMoveTo } from "@/service/api/file";

export default {
  data() {
    return {
      dialog: false,
      data_arr: [],
      directoryDate: [],
      directory_path: [],
      categoryIndex: 0, //点击当前背景变成白色索引
      index: -1,
    };
  },

  methods: {
    async getDirectory(directory_uuid, tricode) {
      if (!directory_uuid || !tricode) {
        directory_uuid = "";
        tricode = "";
      }
      var directory = await popBoxGetFileDirectory({
        directory_uuid: directory_uuid,
        directory_type: "1",
        tricode: tricode,
      });
      this.directoryDate = directory.mrbase_sys_directory_sub;
      this.directory_path = directory.mrbase_sys_directory_path;
    },
    SelectDirectory(row, column, event) {
      alert(1);
    },
    async telsave() {
      if (this.index != -1) {
        var ok = await fileMoveTo({
          directory_uuid: this.directoryDate[this.index].uuid,
          uuid: this.data_arr.join(","),
        });

        this.$emit("fatherMethod");
        if (ok.code == 200) {
          this.$Message({ text: this.$t("error_SUCCESS") });

          this.data_arr = [];
          this.directoryDate = [];
          this.directory_path = [];
          this.dialog = false;
        }
      } else {
        this.$Message({ text: "label_001-018_001-017-003_control_file" });
      }
    },
    telclose() {
      this.data_arr = [];
      this.directoryDate = [];
      this.directory_path = [];
      this.dialog = false;
    },
    async startUp(arr) {
      this.dialog = true;
      arr.forEach((element) => {
        this.data_arr.push(element.uuid);
      });

      var directory = await popBoxGetFileDirectory({
        directory_type: "1",
      });
      this.directoryDate = directory.mrbase_sys_directory_sub;
    },
  },
};
</script>
<style scoped>
.directory {
  color: #383838;
}
.directory :hover {
  color: #0f46c1;
}
.active {
  color: #0f46c1;
  text-decoration: underline;
}
</style>